import { useState, useEffect } from 'react';
import axios from 'axios';
import * as MuiIcons from '@mui/icons-material';

export function useShippingAddresses(wuujuID) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getIconComponent = (iconName) => {
    // Si el icono existe en MUI, lo retornamos con los estilos
    if (MuiIcons[iconName]) {
      const IconComponent = MuiIcons[iconName];
      return <IconComponent sx={{ fontSize: { xs: '4vw', sm: '2vw' }, marginLeft: "0.6vw" }} />;
    }
    // Si no existe, retornamos el ShoppingCartOutlined por defecto
    return <MuiIcons.ShoppingCartOutlined sx={{ fontSize: { xs: '4vw', sm: '2vw' }, marginLeft: "0.6vw" }} />;
  };

  useEffect(() => {
    if (!wuujuID) return;

    const fetchAddresses = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/shipping-addresses/`,
          { withCredentials: true }
        );

        const data = Array.isArray(res.data)
          ? res.data
          : res.data?.results || [];

        const formatted = data.map(item => {
          const extra_fields = item.custom_data?.extra_fields || {};

          return {
            name: item.name,
            apellido: item.variable_last_name?.replace('{{WUUJU_ID}}', wuujuID) || '',
            text: item.name,
            color: item.custom_data.color || '#000',
            pText: item.custom_data.pText || '',
            messageHeight: item.custom_data.message_height || '20vw',
            icon: getIconComponent(item.icon),
            order: item.order || 0,
            lateralMessage: item.lateral_message || '',
            variable: {
              Direccion: item.address,
              Apto: extra_fields.apto || null,
              Estado: item.state,
              Ciudad: item.city,
              CodigoPostal: item.postal_code,
              Telefono: extra_fields.phone || null,
            }
          };
        });

        // Sort the options by order
        formatted.sort((a, b) => a.order - b.order);
        
        setOptions(formatted);
      } catch (err) {
        setError(err.message || 'Error al cargar direcciones');
      } finally {
        setLoading(false);
      }
    };

    fetchAddresses();
  }, [wuujuID]);

  return { options, loading, error };
}
